import request from '@/utils/request'

/**
 * 获取销售成本明细列表
 * @param {Object} params 查询参数
 * @returns {Promise}
 */
export function getSellingCostDetailList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/mallReport/sellingCostDetail',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}